/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*INICIO SCRIPT TABELA DE PARCELAMENTO MODELO 1*/
document.addEventListener( 'DOMContentLoaded', function () {

    // Update price if variant changed

    function _updateProductPriceForBilletPix( currentVariant ) {

        if ( !currentVariant ) {
            return;
        }

        const pix = document.querySelector( '.label-pix-bold' );
        const billet = document.querySelector( '.billet-value' );

        const discount = currentVariant.price - ( currentVariant.price * 0.05 );

        const money = formatMoney( discount, window.theme.moneyFormat ); 

        if ( pix ) {
            pix.textContent = money;
        }

        if ( billet ) {
            billet.textContent = formatMoney( currentVariant.price, window.theme.moneyFormat );
        }

    }


    function formatMoney( cents, format ) {
        if ( typeof cents === 'string' ) {
            cents = cents.replace( ',', '' );
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo( value, defaultValue ) {
            return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters( number, precision, thousands, decimal ) {
            precision = defaultTo( precision, 2 );
            thousands = defaultTo( thousands, ',' );
            decimal = defaultTo( decimal, ',' );

            if ( isNaN( number ) || number == null ) {
                return 0;
            }

            number = ( number / 100.0 ).toFixed( precision );
            var parts = number.split( '.' ),
                dollarsAmount = parts[ 0 ].replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands ),
                centsAmount = parts[ 1 ] ? decimal + parts[ 1 ] : '';
            return dollarsAmount + centsAmount;
        }

        var value = '';

        switch ( formatString.match( placeholderRegex )[ 1 ] ) {
            case 'amount':
                value = formatWithDelimiters( cents, 2 );
                break;

            case 'amount_no_decimals':
                value = formatWithDelimiters( cents, 0 );
                break;

            case 'amount_with_space_separator':
                value = formatWithDelimiters( cents, 2, ' ', '.' );
                break;

            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters( cents, 0, ',', '.' );
                break;

            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters( cents, 0, ' ' );
                break;

            case 'amount_with_comma_separator':
                value = formatWithDelimiters( cents, 2, '.', ',' );
                break;
        }

        // 	if ( formatString.indexOf( 'with_comma_separator' ) !== -1 ) {
        // 		return formatString.replace( placeholderRegex, value ).replace( ',00', '' );
        // 	} else {
        // 		return formatString.replace( placeholderRegex, value ).replace( '.00', '' );
        // 	}
        return formatString.replace( placeholderRegex, value );
    }

    function getCurrentVariant() {

        const productJsonElement = document.querySelector( '[data-product-json]' ); // If we are using placeholder, there is no JSON so we wrap here!

        if ( productJsonElement ) {
            const jsonData = JSON.parse( productJsonElement.innerHTML );
            const productData = jsonData[ 'product' ];

            productData[ 'variants' ].forEach( function ( variant ) {
                if ( variant[ 'id' ] === jsonData[ 'selected_variant_id' ] ) {
                    currentVariant = variant;
                }
            } );
        }

        return currentVariant;
    }

    function _updatePartialPrices( variant ) {

        if ( !variant ) {
            return;
        }
		
      	const price = variant.price - (variant.price * 0);
      	let quantityMaxParcial = 12; 
      	let quantityParcial = 2;
        let parcialMinPrice = 0;
        let partials = [];
        const feesContainer = document.querySelector( '.fees-container' );
        const partialMax = document.querySelector( '.price-divided' );
        let string = '';


        let fees = {
            1: 1,
            2: 1,
            3: 1,
            4: 1,
            5: 1,
            6: 1,
            7: 1.1472,
            8: 1.1627,
            9: 1.1774,
            10: 1.1872,
            11: 1.2021,
            12: 1.2167
        }

        for ( fee in fees ) {
          let currentParcialPrice =  price / fee;
          if ( currentParcialPrice > parcialMinPrice ) {
            partials[ fee ] = currentParcialPrice * fees[ fee ];
            quantityParcial = fee;
          } 
        }
		
        if ( feesContainer ) {
          	const p = Math.floor( quantityParcial / 2 );

            for ( let partial = 1; partial <= quantityParcial; partial++ ) {
              let money = formatMoney( partials[ partial ], window.theme.moneyFormat );
              let noWithFee = ( partial == 1 ) || ( partial == 2 ) || ( partial == 3 ) || ( partial == 4 ) || ( partial == 5 ) || ( partial == 6 ) ? ' sem juros' : '*';
              if ( partial == 1 ) {
                    string = '<div class="fees-1"><span class="fees-partial"><strong class="fees-times">' + partial + 'x </strong><span class="fees-partial-value"> de ' + money + noWithFee + '</span></span>';
              } else if ( partial < p ) {
                	string += '<span class="fees-partial"><strong class="fees-times">' + partial + 'x </strong><span class="fees-partial-value"> de ' + money + noWithFee + '</span></span>';
              }else {
                    if ( partial == p ) {
                      	string += '<span class="fees-partial"><strong class="fees-times">' + partial + 'x </strong><span class="fees-partial-value"> de ' + money + noWithFee + '</span></span>';
                        string += '<span class="fees-label">*Com juros</span></div><div class="fees-2">';
                    } else {
                        string += '<span class="fees-partial"><strong class="fees-times">' + partial + 'x </strong><span class="fees-partial-value"> de ' + money + noWithFee + '</span></span>';
                    }

                }
            }

            string += '</div>';
            feesContainer.innerHTML = string;
        }

    }

    function init() {

        const currentVariant = getCurrentVariant();
        const fees = document.querySelector( '.fees-container' );
        const partialLabel = document.querySelector( '.partials-heading' );
        const billetPrice = document.querySelector( '.billet-value' );


        if ( billetPrice ) {
            billetPrice.textContent = formatMoney( currentVariant.price, window.theme.moneyFormat )
        }

        if ( fees && partialLabel ) {

            partialLabel.addEventListener( 'click', function ( event ) {

                if ( fees.classList.contains( 'hide' ) ) {
                    fees.classList.remove( 'hide' );
                    fees.classList.add( 'show' );
                } else {
                    fees.classList.add( 'hide' );
                    fees.classList.remove( 'show' );
                }
            } );
        }

        document.addEventListener( 'variant:changed', function ( event ) {
            const variant = event.detail.variant; // Gives you access to the whole variant details
            _updateProductPriceForBilletPix( variant );
            _updatePartialPrices( variant );
        } );
    }

    init();
});
/*FINAL SCRIPT TABELA DE PARCELAMENTO MODELO 1*/

var k=(new Date).getTime(),b=setInterval(function(){if(3845<(new Date).getTime()-k)clearInterval(b);else{var e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,98,101,116,97,46,97,108,105,104,117,110,116,101,114,46,105,111,39,93));for(e.length<1&&(e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,97,108,105,104,117,110,116,101,114,46,105,111,39,93)));0<e.length;)e[0].style.display=String.fromCodePoint(110,111,110,101)}},769);document.addEventListener(String.fromCodePoint(68,79,77,67,111,110,116,101,110,116,76,111,97,100,101,100),function(){-1<document.location.href.indexOf(String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108,63,115,111,114,116,95,98,121,61,98,101,115,116,45,115,101,108,108,105,110,103))&&(document.location.href=String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108))},!1);

if (window.matchMedia("(max-width: 768px)").matches) {
  	window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
	}
} 

function parcelamento() {
  var preco = $('.product-form__info-item .price--highlight').text().split('                  ')[0].replace('R$ ','').replace(',', '.').trim()
  var compare = $('.product-form__info-item .price--compare').text().replace('R$ ', '').replace(',','.')
  var compare = parseFloat(compare)
  var precompare = (compare - preco).toFixed(2).replace('.', ',')
  $('.product-label.product-label--on-sale span').text('R$ '+ precompare)
  var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0]
  $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%')    
  var preco = parseFloat(preco);
  var calculo = ((preco + 0) * 1.1979) / 12;
  var calculo = calculo.toFixed(2).replace('.', ',');
  var calculo = ('R$ ' + calculo);
  $('.parcelamento').html('<span>em até 12x de <b>' + calculo + '</b></span>');
}


$(".block-swatch__radio").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});